// extracted by mini-css-extract-plugin
export default {"title":"TaxonomyLoading_title__LWc5n"};